import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '../../../shared/services/sidebar.service';
import { MapPopupComponent } from '../map-popup.component';
import { AuthService } from '@app/shared/services/auth.service';
import { MapService } from '@app/energy-map/services/map.service';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';

@Component({
  selector: 'app-producer-info-popup',
  templateUrl: './producer-info-popup.component.html',
  styleUrls: ['./producer-info-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProducerInfoPopupComponent extends MapPopupComponent implements OnInit {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  public isEnergieMonitorEnabled: boolean = false;
  public externalProducerId: string = '';
  public dsoIdentifier: string = '';
  public formattedInOperationDate: string = '';
  public formattedNominalGeneratorPower: string = '';
  public formattedStreetHouse: string = '';
  public formattedZipCode: string = '';

  constructor(public authService: AuthService, public mapService: MapService, public sidebarService: SidebarService, private router: Router) {
    super();
  }

  public ngOnInit(): void {
    this.isEnergieMonitorEnabled = environment.featureEnergieMonitorV2Enabled && this.authService.permissions.ENERGY_MONITOR;
    this.initializeProducerInfo();
  }

  private initializeProducerInfo(): void {
    this.updateExternalProducerId();
    this.formatAddress();
    this.formatInOperationDate();
    this.formatNominalGeneratorPower();
    this.updateDsoIdentifier();
  }

  private updateExternalProducerId(): void {
    this.externalProducerId = this.data?.externalProducerId ?? '&ndash;';
  }

  private formatAddress(): void {
    const { street, houseNumber, zipCode } = this.data || {};

    if (street || houseNumber) {
      this.formattedStreetHouse = `${street ?? ''} ${houseNumber ?? ''}`.trim();
    }

    this.formattedZipCode = zipCode ?? '';

    if (!street && !houseNumber && !zipCode) {
      this.formattedStreetHouse = '&ndash;';
      this.formattedZipCode = '';
    }
  }

  private formatInOperationDate(): void {
    if (!this.data?.inOperationDate) {
      this.formattedInOperationDate = '&ndash;';
      return;
    }

    const date = new Date(this.data.inOperationDate);
    this.formattedInOperationDate = new Intl.DateTimeFormat('de-DE').format(date);
  }

  private formatNominalGeneratorPower(): void {
    this.formattedNominalGeneratorPower = this.data?.nominalGeneratorPower ? `${this.data.nominalGeneratorPower.toString().replace('.', ',')}  kW` : '&ndash;';
  }

  private updateDsoIdentifier(): void {
    this.dsoIdentifier = this.data?.dsoidentifier ? `Netzbetreiber ${this.data.dsoidentifier}` : '&ndash;';
  }

  public openEnergieMonitorV2(): void {
    this.router.navigate(['/energiemonitorv2']);
  }

  public closePopup(): void {
    this.closeEvent.emit();
  }

  public trackByFn(_: number, item: any): any {
    return item.assetId;
  }
}
